"use strict";
exports.__esModule = true;
exports.getTourismTaxComparisonSummary = exports.calculateTourismTaxRevenue = void 0;
var hyper_utils_1 = require("hyper-utils");
var enums_1 = require("../enums");
var services_1 = require("../services");
function calculateTourismTaxRevenue(io) {
    if (!services_1.CommonLibUtils.isNumber(io.TOURISM_TAX_PERCENTAGE))
        throw new Error("Provide TOURISM_TAX_PERCENTAGE. ");
    if (!services_1.CommonLibUtils.isNumber(io.TOURISM_TRANSIENT_RENTALS_ALLOWANCE_PERCENTAGE))
        io.TOURISM_TRANSIENT_RENTALS_ALLOWANCE_PERCENTAGE = 0;
    var IsFoodAndBeverageEnabled = io.IS_FOOD_AND_BEVERAGE_ENABLED == 1;
    var objRevenue = {
        TOURISM_TRANSIENT_RENTALS_GROSS_REVENUE: io.TOURISM_TRANSIENT_RENTALS_GROSS_REVENUE,
        TOURISM_TRANSIENT_RENTALS_TAX_COLLECTED: Number(io.TOURISM_TRANSIENT_RENTALS_TAX_COLLECTED || 0),
        TOURISM_FOOD_AND_BEVERAGE_TAX_COLLECTED: Number(io.TOURISM_FOOD_AND_BEVERAGE_TAX_COLLECTED || 0),
        TOURISM_TRANSIENT_RENTALS_EXEMPT_REVENUE: io.TOURISM_TRANSIENT_RENTALS_EXEMPT_REVENUE,
        TOURISM_FOOD_AND_BEVERAGE_GROSS_REVENUE: IsFoodAndBeverageEnabled
            ? io.TOURISM_FOOD_AND_BEVERAGE_GROSS_REVENUE
            : 0,
        TOURISM_FOOD_AND_BEVERAGE_EXEMPT_REVENUE: IsFoodAndBeverageEnabled
            ? io.TOURISM_FOOD_AND_BEVERAGE_EXEMPT_REVENUE
            : 0,
        IS_FOOD_AND_BEVERAGE_ENABLED: io.IS_FOOD_AND_BEVERAGE_ENABLED,
        TOURISM_TRANSIENT_RENTALS_PENALTY: io.TOURISM_TRANSIENT_RENTALS_PENALTY,
        TOURISM_TRANSIENT_RENTALS_INTEREST: io.TOURISM_TRANSIENT_RENTALS_INTEREST,
        TOURISM_FOOD_AND_BEVERAGE_PENALTY: io.TOURISM_FOOD_AND_BEVERAGE_PENALTY,
        TOURISM_FOOD_AND_BEVERAGE_INTEREST: io.TOURISM_FOOD_AND_BEVERAGE_INTEREST,
        TOURISM_FOOD_AND_BEVERAGE_ALLOWANCE_PERCENTAGE: io.TOURISM_FOOD_AND_BEVERAGE_ALLOWANCE_PERCENTAGE,
        TOURISM_TRANSIENT_RENTALS_ALLOWANCE_PERCENTAGE: io.TOURISM_TRANSIENT_RENTALS_ALLOWANCE_PERCENTAGE,
        TOURISM_TAX_PERCENTAGE: io.TOURISM_TAX_PERCENTAGE,
        TOURISM_TAX_CONVENIENCE_FEE: io.TOURISM_TAX_CONVENIENCE_FEE || 0,
        TOURISM_TAX_FOOD_AND_BEVERAGE_PERCENTAGE: io.TOURISM_TAX_FOOD_AND_BEVERAGE_PERCENTAGE
    };
    objRevenue._TOURISM_TOTAL_TAX_DUE = 0;
    objRevenue._TOURISM_TOTAL_NET_REVENUE = 0;
    objRevenue._TOURISM_TOTAL_ALLOWANCE = 0;
    if (objRevenue.TOURISM_TRANSIENT_RENTALS_GROSS_REVENUE !== undefined) {
        objRevenue._TOURISM_TRANSIENT_RENTALS_NET_REVENUE =
            objRevenue.TOURISM_TRANSIENT_RENTALS_GROSS_REVENUE -
                (objRevenue.TOURISM_TRANSIENT_RENTALS_EXEMPT_REVENUE || 0);
        objRevenue._TOURISM_TOTAL_NET_REVENUE +=
            objRevenue._TOURISM_TRANSIENT_RENTALS_NET_REVENUE;
        objRevenue._TOURISM_TRANSIENT_RENTALS_DUE = hyper_utils_1.CommonUtils.getPercentage(objRevenue._TOURISM_TRANSIENT_RENTALS_NET_REVENUE, objRevenue.TOURISM_TAX_PERCENTAGE);
        objRevenue._TOURISM_TOTAL_TAX_DUE +=
            objRevenue._TOURISM_TRANSIENT_RENTALS_DUE;
        objRevenue._TOURISM_TRANSIENT_RENTALS_ALLOWANCE = hyper_utils_1.CommonUtils.getPercentage(objRevenue._TOURISM_TRANSIENT_RENTALS_NET_REVENUE, objRevenue.TOURISM_TRANSIENT_RENTALS_ALLOWANCE_PERCENTAGE);
        if (objRevenue._TOURISM_TRANSIENT_RENTALS_ALLOWANCE > 30)
            objRevenue._TOURISM_TRANSIENT_RENTALS_ALLOWANCE = 30;
        objRevenue._TOURISM_TOTAL_ALLOWANCE +=
            objRevenue._TOURISM_TRANSIENT_RENTALS_ALLOWANCE;
    }
    if (objRevenue.TOURISM_FOOD_AND_BEVERAGE_GROSS_REVENUE !== undefined &&
        IsFoodAndBeverageEnabled) {
        if (!services_1.CommonLibUtils.isNumber(io.TOURISM_TAX_FOOD_AND_BEVERAGE_PERCENTAGE))
            throw new Error("Provide TOURISM_TAX_FOOD_AND_BEVERAGE_PERCENTAGE. ");
        if (!services_1.CommonLibUtils.isNumber(io.TOURISM_FOOD_AND_BEVERAGE_ALLOWANCE_PERCENTAGE))
            io.TOURISM_FOOD_AND_BEVERAGE_ALLOWANCE_PERCENTAGE = 0;
        objRevenue._TOURISM_FOOD_AND_BEVERAGE_NET_REVENUE =
            objRevenue.TOURISM_FOOD_AND_BEVERAGE_GROSS_REVENUE -
                (objRevenue.TOURISM_FOOD_AND_BEVERAGE_EXEMPT_REVENUE || 0);
        objRevenue._TOURISM_TOTAL_NET_REVENUE +=
            objRevenue._TOURISM_FOOD_AND_BEVERAGE_NET_REVENUE;
        objRevenue._TOURISM_FOOD_AND_BEVERAGE_DUE = hyper_utils_1.CommonUtils.getPercentage(objRevenue._TOURISM_FOOD_AND_BEVERAGE_NET_REVENUE, objRevenue.TOURISM_TAX_FOOD_AND_BEVERAGE_PERCENTAGE);
        objRevenue._TOURISM_TOTAL_TAX_DUE +=
            objRevenue._TOURISM_FOOD_AND_BEVERAGE_DUE;
        objRevenue._TOURISM_FOOD_AND_BEVERAGE_ALLOWANCE = hyper_utils_1.CommonUtils.getPercentage(objRevenue._TOURISM_FOOD_AND_BEVERAGE_NET_REVENUE, objRevenue.TOURISM_FOOD_AND_BEVERAGE_ALLOWANCE_PERCENTAGE);
        if (objRevenue._TOURISM_FOOD_AND_BEVERAGE_ALLOWANCE > 30)
            objRevenue._TOURISM_FOOD_AND_BEVERAGE_ALLOWANCE = 30;
        objRevenue._TOURISM_TOTAL_ALLOWANCE +=
            objRevenue._TOURISM_FOOD_AND_BEVERAGE_ALLOWANCE;
    }
    objRevenue._TOURISM_AMOUNT_TO_BE_PAID =
        objRevenue._TOURISM_TOTAL_TAX_DUE - objRevenue._TOURISM_TOTAL_ALLOWANCE;
    if (objRevenue._TOURISM_AMOUNT_TO_BE_PAID > 0) {
        objRevenue._TOURISM_AMOUNT_TO_BE_PAID +=
            objRevenue.TOURISM_TAX_CONVENIENCE_FEE;
    }
    return objRevenue;
}
exports.calculateTourismTaxRevenue = calculateTourismTaxRevenue;
function getTourismTaxComparisonSummary(options) {
    if (options === void 0) { options = {}; }
    var actualTax = Number(options.TaxCollected) || 0;
    var idealTax = parseFloat(Number(options.TaxDue || 0).toFixed(2));
    var taxAmt = Number(idealTax);
    var differenceBy = parseFloat((actualTax - idealTax).toFixed(2));
    var result = {};
    if (differenceBy === 0) {
        result.label = "EQUAL";
        result.color = "green";
    }
    else if (differenceBy > 0) {
        result.label = "GREATER";
        result.color = "blue";
    }
    else {
        result.label = "LESS";
        result.color = "red";
    }
    if (differenceBy > 0) {
        taxAmt = Number(actualTax);
    }
    var payableAmt = taxAmt;
    var ShowTick = undefined;
    if ((options === null || options === void 0 ? void 0 : options.TaxVarianceThresholdType) &&
        (options === null || options === void 0 ? void 0 : options.TaxVarianceThresholdValue) &&
        differenceBy !== 0) {
        var TaxVarianceAmount = 0;
        if ((options === null || options === void 0 ? void 0 : options.TaxVarianceThresholdType) === enums_1.PERCENTAGE_VALUE_TYPE.PERCENTAGE) {
            TaxVarianceAmount = hyper_utils_1.CommonUtils.getPercentage(idealTax, options.TaxVarianceThresholdValue);
        }
        else if ((options === null || options === void 0 ? void 0 : options.TaxVarianceThresholdType) === enums_1.PERCENTAGE_VALUE_TYPE.AMOUNT) {
            TaxVarianceAmount = options.TaxVarianceThresholdValue || 0;
        }
        ShowTick =
            TaxVarianceAmount > 0 && Math.abs(differenceBy) <= TaxVarianceAmount;
    }
    return { result: result, differenceBy: differenceBy, payableAmt: payableAmt, ShowTick: ShowTick };
}
exports.getTourismTaxComparisonSummary = getTourismTaxComparisonSummary;
//# sourceMappingURL=tourismTaxFilingUtils.js.map